import { render } from "./HeaderItem.vue?vue&type=template&id=3f394fff&scoped=true"
import script from "./HeaderItem.vue?vue&type=script&lang=js"
export * from "./HeaderItem.vue?vue&type=script&lang=js"

import "./HeaderItem.vue?vue&type=style&index=0&id=3f394fff&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f394fff"]])

export default __exports__